/**
 * UTM Parameters Preservation Utility
 * Ensures UTM parameters are passed along when redirecting to ticket purchase
 */

/**
 * Get all UTM parameters and tracking IDs from current URL
 * @returns Object with all UTM parameters
 */
export function getAllUtmParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};

  urlParams.forEach((value, key) => {
    if (value) params[key] = value;
  });

  return params;
}

/**
 * Build query string from parameters object
 * @param {Object} params - Parameters object
 * @returns {string} Query string (e.g., "?utm_source=ig&utm_campaign=123")
 */
export function buildQueryString(params) {
  const entries = Object.entries(params);
  
  if (entries.length === 0) {
    return '';
  }
  
  const queryString = entries
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  
  return `?${queryString}`;
}

/**
 * Append UTM parameters to a URL
 * @param {string} baseUrl - Base URL to append parameters to
 * @returns {string} URL with UTM parameters appended
 */
export function appendUtmParams(baseUrl) {
  const params = getAllUtmParams();
  const queryString = buildQueryString(params);
  
  if (!queryString) {
    return baseUrl;
  }
  
  // Check if base URL already has query parameters
  // If it has '?', append with '&', otherwise append the full queryString (with '?')
  const finalUrl = baseUrl.includes('?') 
    ? baseUrl + '&' + queryString.substring(1) // Remove leading '?' and use '&'
    : baseUrl + queryString; // Keep the '?' from queryString
  
    
  return finalUrl;
}

/**
 * Get ticket purchase URL with UTM parameters
 * @returns {string} Full URL to ticket purchase with UTM parameters
 */
export function getTicketPurchaseUrl() {
  const baseUrl = 'https://my.brain-event.com';
  return appendUtmParams(baseUrl);
}

/**
 * Initialize UTM parameter preservation
 * Logs all detected UTM parameters
 */
export function initUtmParamTracking() {
  const params = getAllUtmParams();
  const paramCount = Object.keys(params).length;
  
  if (paramCount > 0) {
      } else {
      }
}
